import { getI18n as e, registerEntityEndpoint as t } from "@editor/ui-utils";
//#region ../../../framework/utils/brands/dist/brandEnums.js
var n;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(n ||= {}), Object.freeze(n);
var r;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(r ||= {}), Object.freeze(r), Object.freeze([
	n.MITTIER,
	n.MITSTERNEN,
	n.MITBEZIEHUNG,
	n.TVTODAY,
	n.TVSPIELFILM
]), Object.freeze({
	[n.BUNTE]: "bunte",
	[n.CHIP]: "chip",
	[n.FOCUS]: "focus",
	[n.FITFORFUN]: "fitforfun",
	[n.FINANZEN100]: "finanzen100",
	[n.MITTIER]: "default-verticals",
	[n.MITSTERNEN]: "default-verticals",
	[n.MITBEZIEHUNG]: "default-verticals",
	[n.TVTODAY]: "default",
	[n.TVSPIELFILM]: "default"
});
var i = Object.freeze(Object.values(n));
Object.freeze(Object.values(r)), n.BUNTE, n.CHIP, n.FOCUS, n.FITFORFUN, n.TVSPIELFILM, n.TVTODAY;
var a = {
	"bunte-stack": n.BUNTE,
	interred: n.CHIP,
	escenic: n.FOCUS,
	"fff-cms": n.FITFORFUN,
	"tvs-cms": n.TVSPIELFILM,
	"tvt-cms": n.TVTODAY
}, o = {
	title: "",
	legacyAuthorUuid: void 0,
	biography: "",
	isEnabled: !1,
	showImageOnTeasers: !1,
	type: "BRAND_AUTHOR"
}, s = (e) => ({
	...o,
	brand: e
}), c = t("Authors"), { getEntity: l, listEntities: u, putEntity: d, postEntity: f, deleteEntity: p } = c, m = async (e, t = {}) => u({ params: {
	search: e,
	...t
} }), h = async (e) => l(e), g = async (e) => f(e), _ = async (e) => {
	let { _id: t, ...n } = e;
	return d(t, n);
}, v = async (e) => p(e), y = () => ({
	firstname: "",
	lastname: "",
	affiliation: "",
	showArticles: !0,
	brandAuthorsRef: i.map(s),
	socialLinks: {
		twitter: "",
		facebook: "",
		tiktok: "",
		instagram: "",
		xing: "",
		linkedin: "",
		email: ""
	},
	vgWort: "",
	paths: [{
		type: "generated",
		path: "",
		createDate: /* @__PURE__ */ new Date()
	}],
	isDeleted: !1,
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	},
	jobTitlePrefix: "default",
	createDate: /* @__PURE__ */ new Date(),
	changeDate: /* @__PURE__ */ new Date(),
	_id: ""
}), b = (...e) => {
	let t = /* @__PURE__ */ new Set(), n = [];
	for (let r of e) for (let e of r) t.has(e._id) || (t.add(e._id), n.push(e));
	return n;
}, x = (e) => {
	if (typeof e != "object" || !e || Reflect.get(e, "isAxiosError") !== !0) return !1;
	let t = Reflect.get(e, "response");
	return typeof t == "object" && !!t && Reflect.get(t, "status") === 404;
}, S = (t) => ({
	...y(),
	_id: t,
	firstname: e().t("authors.deletedAuthor"),
	lastname: "",
	isDeleted: !0
}), C = (t) => ({
	...y(),
	_id: t,
	firstname: e().t("authors.errorFailedLoadAuthor"),
	lastname: ""
}), w = async (e) => {
	try {
		return await l(e, { handleError: !1 });
	} catch (t) {
		if (x(t)) return S(e);
		throw t;
	}
}, T = async (e, t) => {
	let n = new Map(t.map((e) => [e._id, e]));
	return (await Promise.allSettled(e.map(async (e) => n.get(e) || w(e)))).map((t, n) => t.status === "fulfilled" ? t.value : C(e[n] ?? ""));
}, E = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
//#endregion
export { h as a, b as c, T as d, s as f, a as h, _ as i, g as l, n as m, c as n, m as o, i as p, v as r, y as s, E as t, w as u };

//# sourceMappingURL=_plugin-vue_export-helper-B-med9Jm.js.map